import type { LanguageKeys, LanguageObject } from '../types';

export const LANGUAGES: Record<LanguageKeys, LanguageObject> = {
  en: {
    display: 'English',
    value: 'en',
    url: 'en-us',
    active: true,
    urlPrefix: '/',
    country: 'US',
    filePath: 'en',
    regExp: '/en-en',
    sitemapIncluded: true,
    isVerbose: false,
    locale: 'en-US',
  },
  it: {
    display: 'Italiano',
    value: 'it',
    url: 'it-it',
    active: true,
    urlPrefix: '/it-it/',
    country: 'IT',
    filePath: 'it-it',
    regExp: '/it-it',
    sitemapIncluded: true,
    isVerbose: true,
    locale: 'it-IT',
  },
  de: {
    display: 'Deutsch',
    value: 'de',
    url: 'de-de',
    urlPrefix: '/de-de/',
    active: true,
    country: 'DE',
    filePath: 'de-de',
    regExp: '/de-de',
    sitemapIncluded: true,
    isVerbose: true,
    locale: 'de-DE',
  },
  fr: {
    display: 'Français',
    value: 'fr',
    url: 'fr-fr',
    urlPrefix: '/fr-fr/',
    active: true,
    country: 'FR',
    filePath: 'fr-fr',
    regExp: '/fr-fr',
    sitemapIncluded: true,
    isVerbose: true,
    locale: 'fr-FR',
  },
  ja: {
    display: '日本語',
    value: 'ja',
    urlPrefix: '/ja-jp/',
    active: true,
    url: 'ja-jp',
    country: 'JP',
    filePath: 'ja-jp',
    regExp: '/ja-jp',
    sitemapIncluded: true,
    isVerbose: false,
    locale: 'ja-JP',
  },
  zh: {
    display: '简体中文',
    value: 'zh',
    urlPrefix: '/zh-cn/',
    url: 'zh-cn',
    active: true,
    country: 'CN',
    filePath: 'zh-cn',
    regExp: '/zh-cn',
    sitemapIncluded: true,
    isVerbose: false,
    locale: 'zh-CN',
  },
  en_gb: {
    display: 'English (UK)',
    value: 'en_gb',
    urlPrefix: '/en-gb/',
    url: 'en-gb',
    active: true,
    country: 'UK',
    filePath: 'en-gb',
    regExp: '/en-gb',
    sitemapIncluded: true,
    isVerbose: false,
    locale: 'en-GB',
  },
  ko: {
    display: '한국어',
    value: 'ko',
    urlPrefix: '/ko-kr/',
    url: 'ko-kr',
    active: true,
    country: 'KR',
    filePath: 'ko-kr',
    regExp: '/ko-kr',
    sitemapIncluded: true,
    isVerbose: true,
    locale: 'ko-KR',
  },
  es_es: {
    display: 'Español (ES)',
    value: 'es_es',
    urlPrefix: '/es-es/',
    url: 'es-es',
    active: true,
    country: 'ES',
    filePath: 'es-es',
    regExp: '/es-es',
    sitemapIncluded: true,
    isVerbose: true,
    locale: 'es-ES',
  },
  es_mx: {
    display: 'Español (MX)',
    value: 'es_mx',
    urlPrefix: '/es-mx/',
    url: 'es-mx',
    active: true,
    country: 'MX',
    filePath: 'es-mx',
    regExp: '/es-mx',
    sitemapIncluded: true,
    isVerbose: true,
    locale: 'es-MX',
  },
  es_us: {
    display: 'Español (US)',
    value: 'es_us',
    urlPrefix: '/es-us/',
    url: 'es-us',
    active: true,
    country: 'US',
    filePath: 'es-us',
    regExp: '/es-us',
    sitemapIncluded: true,
    isVerbose: true,
    locale: 'es-US',
  },
  zh_tw: {
    display: '繁體中文',
    value: 'zh_tw',
    urlPrefix: '/zh-tw/',
    url: 'zh-tw',
    active: true,
    country: 'CN',
    filePath: 'zh-tw',
    regExp: '/zh-tw',
    sitemapIncluded: true,
    isVerbose: false,
    locale: 'zh-TW',
  },
  fr_ca: {
    display: 'Français (Canada)',
    value: 'fr_ca',
    url: 'fr-ca',
    urlPrefix: '/fr-ca/',
    active: true,
    country: 'CA',
    filePath: 'fr-ca',
    regExp: '/fr-ca',
    sitemapIncluded: true,
    isVerbose: true,
    locale: 'fr-CA',
  },
};

/**
 * basically the prefixes without the slashes included.
 */
export const LANGUAGE_URL_ELEMENTS = [
  ...Object.values(LANGUAGES)
    .filter((i) => i.active)
    .filter((i) => i.value !== 'en')
    .map((i) => i.url),
];

export const LANGUAGE_URL_PREFIXES = [
  ...Object.values(LANGUAGES)
    .filter((i) => i.active)
    .filter((i) => i.value !== 'en')
    .map((i) => i.urlPrefix),
];
